export default __webpack_public_path__ + "static/media/sign_out.3958751a.svg";